export function FloatingKnowledgeButton() {
  const handleClick = () => {
    const event = new CustomEvent('openKnowledge');
    window.dispatchEvent(event);
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all z-40 overflow-hidden border-2 border-white"
      title="Open kennisbank & support"
      aria-label="Open kennisbank"
    >
      <img
        src="https://s3-eu-west-1.amazonaws.com/contaqt-live/drag-drop-images/uploads/144/WDPA3_dibbi.png"
        alt="dibbi Avatar"
        className="w-full h-full object-cover"
      />
    </button>
  );
}
